import { createSlice } from "@reduxjs/toolkit";

import { ExecutorRating } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, ExecutorRating.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateExecutorRatingData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.EXECUTOR_RATING_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateExecutorRatingDataAction =
	globalStateExecutorRatingData.actions;
export const globalStateExecutorRatingDataReducer =
	globalStateExecutorRatingData.reducer;
export type globalStateExecutorRatingDataState = State;

export default globalStateExecutorRatingData;
